module.exports = __webpack_public_path__ + "static/media/pic4.6fd88420.webp";